<template>
    <transition name="fade">
      <router-view />
    </transition>
</template>

<script>
  export default {
    name: 'auth-layout',
    components: {
    },
  }
</script>

<style>
html, body {
  width: 100%;
  height: 100%;
  overflow: auto !important;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>